module.exports = __webpack_public_path__ + "static/media/logout.cece6b28.svg";